import React from 'react';

import classNames from 'classnames';

import { useFilterPayments } from '@widgets/FilterPayments/lib/hooks/useFilterPayments';
import { FilterPaymentsSkeletons } from '@widgets/FilterPayments/ui/FilterPaymentsSkeletons';

import cls from './FilterPayments.module.css';
import { DateInput } from '../../../components/DateInput/DateInput';
import { MultiSelect } from '../../../components/UI/MultiSelect/MultiSelect';
import { Select } from '../../../components/UI/Select/Select';
import { Input } from '../../../components/UI/TextInput/Input';

export const FilterPayments = () => {
    const {
        accountHandler,
        projectHandler,
        statusHandler,
        partnerHandler,
        expenditureHandler,
        deleteHandle,
        selectedPartner,
        selectedProject,
        selectedExpenditure,
        statusExpenditure,
        inputHandler,
        inputFindHandler,
        buttonHandler,
        onPaymentDateChange,
        onAccrualDateChange,
        onPaymentDateChangeCancel,
        onAccrualDateChangeCancel,
        t,
        accounts,
        allAccounts,
        allAccountsArchive,
        projectOptions,
        partnerOptions,
        expenditureOptions,
        statusList,
        inputsState,
        paymentStartDate,
        paymentEndDate,
        accrualStartDate,
        accrualEndDate,
        isLoadingFilters,
    } = useFilterPayments();

    if (isLoadingFilters) {
        return <FilterPaymentsSkeletons />;
    }
    return (
        <>
            <div className={classNames(cls.wrapper)}>
                <MultiSelect
                    selected={accounts}
                    onChange={accountHandler}
                    placeholder={t(
                        'FilterPayments.onAccrualDateChangeCancel.return.accounts.placeholder'
                    )}
                    options={[...allAccounts, ...allAccountsArchive]}
                    deleteHandle={deleteHandle}
                />
                <Select
                    selected={selectedProject}
                    onChange={projectHandler}
                    placeholder={t(
                        'FilterPayments.onAccrualDateChangeCancel.return.selectedProject.placeholder'
                    )}
                    options={projectOptions}
                />
                <Select
                    selected={selectedPartner}
                    onChange={partnerHandler}
                    placeholder={t(
                        'FilterPayments.onAccrualDateChangeCancel.return.selectedPartner.placeholder'
                    )}
                    options={partnerOptions}
                />
                <Select
                    selected={selectedExpenditure}
                    onChange={expenditureHandler}
                    placeholder={t(
                        'FilterPayments.onAccrualDateChangeCancel.return.selectedExpenditure.placeholder'
                    )}
                    options={expenditureOptions}
                />
            </div>
            <div className={classNames(cls.wrapperSecond)}>
                <Select
                    selected={statusExpenditure}
                    onChange={statusHandler}
                    options={statusList}
                />
                <div className={classNames(cls.inputGroup)}>
                    <Input
                        placeholder={t(
                            'FilterPayments.onAccrualDateChangeCancel.return.inputGroup.placeholder.start'
                        )}
                        name="sumStart"
                        value={inputsState.sumStart}
                        onChange={(event) => inputHandler(event)}
                        isFirstItemGroup
                        type="number"
                    />
                    <Input
                        placeholder={t(
                            'FilterPayments.onAccrualDateChangeCancel.return.inputGroup.placeholder.end'
                        )}
                        name="sumEnd"
                        value={inputsState.sumEnd}
                        onChange={(event) => inputHandler(event)}
                        type="number"
                        isGroup
                    />
                </div>
                <DateInput
                    isRequired
                    placeholder={t(
                        'FilterPayments.onAccrualDateChangeCancel.return.paymentDate.placeholder'
                    )}
                    date={`${paymentStartDate} - ${paymentEndDate}`}
                    inventoryGuid="inventoryGuid"
                    parameterName="paymentDate"
                    newCallbackNotSingle={onPaymentDateChange}
                    newCallbackNotSingleCancel={onPaymentDateChangeCancel}
                    options={{
                        autoUpdateInput: false,
                        singleDatePicker: false,
                        showDropdowns: true,
                        autoApply: false,
                    }}
                />
                <DateInput
                    isRequired
                    date={`${accrualStartDate} - ${accrualEndDate}`}
                    inventoryGuid="inventoryGuid"
                    parameterName="paymentDate"
                    placeholder={t(
                        'FilterPayments.onAccrualDateChangeCancel.return.accrualDate.placeholder'
                    )}
                    newCallbackNotSingle={onAccrualDateChange}
                    newCallbackNotSingleCancel={onAccrualDateChangeCancel}
                    options={{
                        autoUpdateInput: false,
                        singleDatePicker: false,
                        showDropdowns: true,
                        autoApply: false,
                    }}
                />
                <Input
                    isRequired
                    placeholder={t(
                        'FilterPayments.onAccrualDateChangeCancel.return.findInput.placeholder'
                    )}
                    name="findInput"
                    value={inputsState.findInput}
                    onChange={(event) => inputFindHandler(event)}
                    button={t('FilterPayments.onAccrualDateChangeCancel.return.findInput.button')}
                    buttonHandler={buttonHandler}
                />
            </div>
            <div className={classNames(cls.clean)}>
                <a href="" onClick={() => location.reload()}>
                    {t('FilterPayments.onAccrualDateChangeCancel.return.clean')}
                </a>
            </div>
        </>
    );
};
